<p-calendar
  [formControl]="$any(formControl)"
  (completeMethod)="to.completeMethod(field, $event)"
  [placeholder]="to.placeholder || ''"
  [timeOnly]="true"
  dataType="string"
></p-calendar>
